import axios from '@/plugins/axios';
import { useToast } from '@/composables/use-toast';
import { logApiError } from '@/services/api';
import { useStorage } from '@/composables/use-storage';
const { userAuthToken } = useStorage();
const { addToast } = useToast();

const getAuthHeaders = () => {
    const token = userAuthToken.value;
    return {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      withCredentials: true
    };
};

const paymentMethodsUrl = '/api/payment_methods';

export const getPaymentMethods = async () => {
    try {
        const response = await axios.get(paymentMethodsUrl, getAuthHeaders());
        return response.data;
        } catch (error) {
          logApiError(error, 'GET', paymentMethodsUrl);
          const errorMessage = error.response?.data?.message ||
            error.message ||
            'Error fetching payment methods';
          addToast(errorMessage, 'error');
          return false;
        }
}

export const getActivePaymentMethods = async () => {
  try {
      const response = await axios.get(`${paymentMethodsUrl}/active`, getAuthHeaders());
      return response.data;
      } catch (error) {
        logApiError(error, 'GET', `${paymentMethodsUrl}/active`);
        const errorMessage = error.response?.data?.message ||
          error.message ||
          'Error fetching active payment methods';
        addToast(errorMessage, 'error');
        return false;
      }
}

export const getPaymentMethodById = async (id) => {
    try {
        const response = await axios.get(`${paymentMethodsUrl}/${id}`, getAuthHeaders());
        return response.data;
        } catch (error) {
          logApiError(error, 'GET', `${paymentMethodsUrl}/${id}`);
          const errorMessage = error.response?.data?.message ||
            error.message ||
            'Error fetching payment method';
          addToast(errorMessage, 'error');
          return false;
        }
}

export const createPaymentMethod = async (data) => {
    try {
        const response = await axios.post(paymentMethodsUrl, data, getAuthHeaders());
        return response.data;
        } catch (error) {
          logApiError(error, 'POST', paymentMethodsUrl);
          const errorMessage = error.response?.data?.message ||
            error.message ||
            'Error creating payment method';
          addToast(errorMessage, 'error');
          return false;
        }
}

export const updatePaymentMethod = async (id, data) => {
    try {
       const response = await axios.post(`${paymentMethodsUrl}/${id}/update`, data, getAuthHeaders());
       return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${paymentMethodsUrl}/${id}/update`, data);
        const errorMessage = error.response?.data?.message ||
        error.message ||
        'Error updating payment method';
        addToast(errorMessage, 'error');
        return false;
    }
}

export const deletePaymentMethod = async (id) => {
    try {
       const response = await axios.post(`${paymentMethodsUrl}/${id}/delete`, getAuthHeaders());
       return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${paymentMethodsUrl}/${id}/delete`);
        const errorMessage = error.response?.data?.message ||
        error.message ||
        'Error deleting payment method';
        addToast(errorMessage, 'error');
        return false;
    }
}

export const togglePaymentMethodActive = async (id, currentActive) => {
    try {
        const response = await axios.post(`${paymentMethodsUrl}/${id}/toggle-active`, !currentActive, getAuthHeaders());
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${paymentMethodsUrl}/${id}/toggle-active`);
        const errorMessage = error.response?.message || error.message || 'Error toggling payment method active';
        addToast(errorMessage, 'error');
        return false;
    }
}
